import {
    getI18nMsg
} from "@/common/helpers/helpers";

const state = {
    notification: {
        snackbar: false,
        y: 'bottom',
        x: null,
        mode: '',
        timeout: 8000,
        text: '',
        color: '#00AEEF'
    },
    agency:0,
    agencyId:undefined,
    agencyName:undefined,
    idApsSos:undefined
}

const getters = {
    notification: state => {
        return state.notification;
    },
    agency:state=>{
		return state.agency;
    },
    agencyId:state=>{
		return state.agencyId;
    },
    agencyName:state=>{
		return state.agencyName;
    },
    idApsSos:state=>{
		return state.idApsSos;
	}
}

const actions = {
    setAgency(context,agencyId){
        context.commit("setAgency",agencyId);
    },
    doSetPropsAgency(context, payload){
        return new Promise((resolve,reject)=>{
            context.commit("mSetPropsAgency",payload);
            resolve();
        })
    }
}
const mutations = {
    setAgency(state,agencyId){
		state.agency=agencyId;
	},
    updateNotificationError(state, text) {
        state.notification.color = 'error';
        state.notification.snackbar = true;
        state.notification.text = getI18nMsg(text);
    },

    updateNotificationInfo(state, text) {
        state.notification.color = 'info';
        state.notification.snackbar = true;
        state.notification.text = getI18nMsg(text);
    },

    updateNotificationWarning(state, text) {
        state.notification.color = 'warning';
        state.notification.snackbar = true;
        state.notification.text = getI18nMsg(text);
    },
    mSetPropsAgency(state, data) {
        state.agencyId = data.agencyId,
        state.agencyName = data.agencyName,
        state.idApsSos = data.idApsSos
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}